<div *ngIf="!(isLoading$ | async)" class="tpn-flow-container">
  <div class="tpn-flow-header">
    <div class="back-button-container">
      <button
        *ngIf="currentStepIndex !== 0 && currentStepIndex !== 4 && !(currentStepIndex === 1 && validGuid === true)"
        class="p-ripple p-element p-button p-component back-button"
        type="button"
        (click)="prevStep()"
      >
        <i class="bi bi-arrow-left" style="font-size: 20px"></i>
      </button>
    </div>
    <div class="logo-container">
      <img [src]="getImageSrc()" alt="Enroll and Pay Logo" class="logo" />
    </div>
    <div class="support-contact" (click)="createCallSupportAnalytics()">
      Call Enroll & Pay support at
      <a href="tel:+1-866-942-5500" class="support-phone-link"> (866) 942-5500</a>
    </div>
  </div>

  <ng-container [ngSwitch]="currentStepIndex">
    <div
      *ngIf="
        showPendingBanner &&
        currentStepIndex !== 0 &&
        merchantRegistrationType !== MerchantRegistrationTypeEnum.Coalition_Flow
      "
      class="alert alert-info d-flex align-items-center"
      role="alert"
    >
      <i class="bi bi-info-circle-fill" style="font-size: 20px; margin-right: 8px; flex-shrink: 0"></i>
      <div class="flex-grow-1">
        Your TPN is currently pending verification. Someone from our team will contact you shortly to complete the
        setup.
      </div>
    </div>

    <!-- Get your TPN -->
    <div class="tpn-flow-content" *ngSwitchCase="0">
      <div class="card tpn-tutorial-card">
        <!-- Welcome Section -->
        <div class="welcome-section">
          <div class="welcome-icon">
            <i class="bi bi-credit-card-2-front" style="font-size: 2rem; color: var(--header-items-color)"></i>
          </div>
          <h2 class="welcome-title">Get Started with {{ coalitionName }}</h2>
          <p class="welcome-description">
            Welcome to the <strong>{{ coalitionName }} Loyalty Program</strong> powered by Enroll & Pay. Let's set up
            your terminal to start enrolling customers.
          </p>
        </div>
        <form [formGroup]="tpnForm" (ngSubmit)="getTpnData()" class="d-flex gap-2 align-items-center pb-2">
          <ep-simple-text-control
            label="Enter your Device's TPN number"
            formControlName="tpn"
            class="mobile-keyboard-input"
            ngClass="device-disabled"
            id="tpn-input"
            data-cy="device-authorization-code"
            (click)="onTpnInputFocus()"
          />
          <p-button type="submit" [disabled]="tpnForm.invalid" class="mt-4">Next</p-button>
        </form>

        <div class="tpn-tutorial mt-2">
          <div class="tpn-tutorial-title">
            <i class="bi bi-info-circle-fill" style="font-size: 2rem; color: var(--header-items-color)"></i>
            <h4 class="tutorial-title">Where is the TPN number?</h4>
          </div>
        </div>

        <p-accordion
          [collapseIcon]=""
          [expandIcon]=""
          [multiple]="true"
          [(activeIndex)]="accordionActiveIndex"
          (activeIndexChange)="onAccordionChange($event)"
          [ngClass]="{ 'accordion-expanded': isExpanded }"
        >
          <div
            class="fake-accordion"
            [ngClass]="{ 'fake-accordion-block': isExpanded }"
            (click)="isExpanded = true; accordionActiveIndex = [0, 1]; onAccordionChange(accordionActiveIndex)"
          >
            <span style="padding-left: 24px">1. Open the DvPay Lite app</span>
            <div style="padding-right: 15px"></div>
          </div>

          <p-accordionTab [iconPos]="'end'" value="0" [selected]="isExpanded">
            <ng-template pTemplate="header">
              <header (click)="isExpanded ? preventCollapse($event) : null" style="width: 100%">
                <span>
                  2. Press
                  <img src="../../assets/images/dejavoo_support.png" alt="Support Button" class="support-image" />
                  at the bottom right</span
                >
              </header>
            </ng-template>

            <div class="tpn-modal-content">
              <div class="step-item">
                <div class="step-content">
                  <h4>Press the Support Button</h4>
                  <p>Look for and press the Support button at the bottom right of the screen.</p>
                  <img
                    src="../../assets/images/dejavoo_01.png"
                    alt="DvPay Lite Support Button"
                    class="tutorial-image"
                  />
                </div>
              </div>
            </div>
          </p-accordionTab>

          <p-accordionTab [iconPos]="'end'" value="1" [selected]="isExpanded">
            <ng-template pTemplate="header">
              <header (click)="isExpanded ? preventCollapse($event) : null" style="width: 100%">
                <span> 3. Locate the 12 digit number next to TPN </span>
              </header>
            </ng-template>
            <div class="step-item">
              <div class="step-content">
                <h4>Locate Your TPN Number</h4>
                <p>Find the 12-digit number displayed next to "TPN" on the support screen.</p>
                <img
                  src="../../assets/images/dejavoo_02.png"
                  alt="TPN Number Location"
                  class="tutorial-image"
                  style="width: 375px"
                />
              </div>
            </div>
          </p-accordionTab>

          <div
            class="fake-accordion"
            [ngClass]="{ 'fake-accordion-block': isExpanded }"
            (click)="isExpanded = true; accordionActiveIndex = [0, 1]; onAccordionChange(accordionActiveIndex)"
          >
            <span style="padding-left: 24px">4. Enter number in the field above</span>
            <div style="padding-right: 15px"></div>
          </div>
        </p-accordion>

        <!-- <p-button type="button" class="mt-4" (click)="openTpnTutorialModal(); createNeedHelpAnalytics()">
          Need Help?
        </p-button> -->
      </div>
    </div>

    <!-- Merchant Information Form -->
    <div class="tpn-flow-content" *ngSwitchCase="1">
      <div class="card">
        <h3 *ngIf="tpnForm.get('tpn')?.value || enrollmentResponse?.SerialNumber">
          {{ coalitionName }} information for {{ tpnForm.get('tpn')?.value || enrollmentResponse?.SerialNumber }}
        </h3>

        <h3 *ngIf="!tpnForm.get('tpn')?.value && !enrollmentResponse?.SerialNumber">Account Setup</h3>

        <div class="d-flex ml-auto">
          <p-button *ngIf="!isMerchantFormEditing" [size]="'small'" (click)="toggleMerchantFormEditing()">
            <i class="bi bi-pencil-square" style="font-size: 14px"></i>
          </p-button>
        </div>

        <form [formGroup]="merchantForm" class="d-flex flex-column gap-1">
          <div class="label-container">
            <span>
              <label class="merchant-label"> {{ isMerchantFormEditing ? 'First Name:' : 'Name:' }}</label>
            </span>
            <ep-simple-text-control
              *ngIf="isMerchantFormEditing; else name"
              formControlName="FirstName"
              class="w-full"
            />

            <ng-template #name>
              <span class="merchant-name-view w-full">
                {{ enrollmentResponse?.Data?.ContactInformation?.FirstName }}
                {{ enrollmentResponse?.Data?.ContactInformation?.LastName }}
              </span>
            </ng-template>
          </div>

          <div *ngIf="isMerchantFormEditing" class="label-container">
            <span>
              <label class="merchant-label"> Last Name:</label>
            </span>
            <ep-simple-text-control formControlName="LastName" class="w-full" />
          </div>

          <div class="label-container">
            <span>
              <label class="merchant-label"> Email:</label>
            </span>
            <ep-simple-text-control *ngIf="isMerchantFormEditing; else email" formControlName="Email" class="w-full" />
            <div
              *ngIf="isMerchantFormEditing && merchantForm.get('Email')?.invalid && merchantForm.get('Email')?.touched"
              class="text-danger mt-1"
            >
              <small *ngIf="merchantForm.get('Email')?.errors?.['invalidEmail']">
                Please enter a valid email address.
              </small>
            </div>
            <ng-template #email>
              <span class="merchant-email-view w-full">{{ enrollmentResponse?.Data?.MerchantEmail }}</span>
            </ng-template>
          </div>
          <div class="label-container">
            <span>
              <label class="merchant-label">Business Name:</label>
            </span>
            <ep-simple-text-control
              *ngIf="isMerchantFormEditing; else businessName"
              label=""
              formControlName="BusinessName"
              class="w-full"
            />
            <ng-template #businessName>
              <span class="merchant-business-name-view w-full">
                {{ enrollmentResponse?.Data?.BusinessInformation?.Name }}
              </span>
            </ng-template>
          </div>
          <div class="label-container">
            <span>
              <label class="merchant-label">Business Phone:</label>
            </span>
            <ep-international-phone-control
              *ngIf="isMerchantFormEditing; else businessPhone"
              [showLabel]="false"
              formControlName="BusinessPhone"
              class="w-full"
            />
            <ng-template #businessPhone>
              <span class="merchant-business-phone-view w-full">
                {{ enrollmentResponse?.Data?.BusinessInformation?.PhoneNumber }}
              </span>
            </ng-template>
          </div>
          <div class="label-container">
            <span>
              <label class="merchant-label"> Full Address:</label>
            </span>
            <ep-simple-text-control
              *ngIf="isMerchantFormEditing; else address"
              label=""
              formControlName="Address"
              class="w-full"
            />
            <ng-template #address>
              <span class="merchant-address-view w-full">
                {{ enrollmentResponse?.Data?.BusinessInformation?.Address }}
              </span>
            </ng-template>
          </div>
          <div class="label-container">
            <span>
              <label class="merchant-label"> Timezone:</label>
            </span>

            <app-us-timezone-dropdown
              *ngIf="isMerchantFormEditing; else timezone"
              class="w-full time-zone-dropdown"
              #TimeZoneEp
              formControlName="Timezone"
              label=""
            />
            <ng-template #timezone>
              <span class="merchant-timezone-view w-full">
                {{ (enrollmentResponse?.Data?.BusinessInformation?.TimeZone | timezone).split(') ')[1] }}
              </span>
            </ng-template>
          </div>

          <div class="align-items-center d-flex flex-column">
            <h3>Choose your Program:</h3>

            <div class="d-flex flex-column gap-2 justify-content-center w-100">
              <div
                class="d-flex flex-column gap-1 loyalty-option"
                (click)="selectLoyaltyOption(1)"
                [ngClass]="{ 'loyalty-option-selected': isDefaultLoyaltyProgramSelected }"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <span class="font-semibold">Default</span>
                  <i
                    *ngIf="isDefaultLoyaltyProgramSelected"
                    class="bi bi-check-circle-fill"
                    style="font-size: 14px; color: var(--sidebar-bg-active)"
                  ></i>
                </div>
                <ul>
                  <li>Enrollment Incentive: Disabled</li>
                  <li>Returning customers get $10 off after earning $100 in points.</li>
                </ul>
              </div>

              <div
                class="d-flex flex-column gap-1 loyalty-option"
                (click)="selectLoyaltyOption(2)"
                [ngClass]="{ 'loyalty-option-selected': isCustomLoyaltyProgramSelected }"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <span class="font-semibold">Design your own</span>
                  <i
                    *ngIf="isCustomLoyaltyProgramSelected"
                    class="bi bi-check-circle-fill"
                    style="font-size: 14px; color: var(--sidebar-bg-active)"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between mb-2 ml-auto mt-2 w-100">
            <p-button type="button" (click)="openHelpModal(); createNeedHelpAnalytics()">Need Help?</p-button>
            <p-button type="submit" [disabled]="merchantForm.invalid" (onClick)="saveProcess()">
              {{ getButtonLabel() }}
            </p-button>
          </div>
        </form>
      </div>
    </div>

    <!-- Custom Enrollment Offer -->
    <div class="tpn-flow-content" *ngSwitchCase="2">
      <div class="card">
        <div class="align-items-center d-flex flex-column">
          <h3>
            {{
              merchantRegistrationType === MerchantRegistrationTypeEnum.Coalition_Flow || isAdmin
                ? 'Choose your Enrollment Offer:'
                : 'Create Instant Offer'
            }}
          </h3>

          <div
            *ngIf="merchantRegistrationType === MerchantRegistrationTypeEnum.Coalition_Flow || isAdmin"
            class="d-flex flex-column gap-2 justify-content-center mt-2 ng-star-inserted"
          >
            <div
              class="d-flex flex-column gap-1 loyalty-option"
              (click)="selectEnrollmentOffer(1)"
              [ngClass]="{ 'loyalty-option-selected': isInstantOfferSelected }"
            >
              <div class="d-flex align-items-center justify-content-between">
                <span class="font-semibold">Instant:</span>
                <i
                  *ngIf="isInstantOfferSelected"
                  class="bi bi-check-circle-fill"
                  style="font-size: 14px; color: var(--sidebar-bg-active)"
                ></i>
              </div>
              <span>
                Offering an instant reward off the customer's bill is one of the most simple and effective ways to gain
                enrollment.
              </span>
            </div>
            <div
              class="d-flex flex-column gap-1 loyalty-option"
              (click)="selectEnrollmentOffer(2)"
              [ngClass]="{ 'loyalty-option-selected': isBonusOfferSelected }"
            >
              <div class="d-flex align-items-center justify-content-between">
                <span class="font-semibold">Bonus Rewards:</span>
                <i
                  *ngIf="isBonusOfferSelected"
                  class="bi bi-check-circle-fill"
                  style="font-size: 14px; color: var(--sidebar-bg-active)"
                ></i>
              </div>
              <span>
                Offering a bonus reward provides the customer with a reward that they can use on any of their future
                purchases.
              </span>
            </div>
            <div
              *ngIf="isAdmin"
              class="d-flex flex-column gap-1 loyalty-option"
              (click)="selectEnrollmentOffer(3)"
              [ngClass]="{ 'loyalty-option-selected': isBonusPointsSelected }"
            >
              <div class="d-flex align-items-center justify-content-between">
                <span class="font-semibold">Bonus Points:</span>
                <i
                  *ngIf="isBonusPointsSelected"
                  class="bi bi-check-circle-fill"
                  style="font-size: 14px; color: var(--sidebar-bg-active)"
                ></i>
              </div>
              <span>
                Offering bonus points provides the customer with points that they can use on any of their future
                purchases.
              </span>
            </div>
          </div>

          <div
            *ngIf="
              isInstantOfferSelected ||
              (!isAdmin && merchantRegistrationType !== MerchantRegistrationTypeEnum.Coalition_Flow)
            "
            class="d-flex flex-column mt-3 w-full align-items-center"
          >
            <h4 *ngIf="merchantRegistrationType === MerchantRegistrationTypeEnum.Coalition_Flow">
              Configure Instant Offer
            </h4>
            <form [formGroup]="instantOfferForm!" class="instant-offer-form" data-cy="instant-offer-form">
              <div class="align-items-center d-flex gap-2 mt-2">
                <span style="min-width: 40px; text-align: right">Instant Reward</span>
                <ep-percentage-control
                  formControlName="InstantReward"
                  data-cy="loyalty-program-instant-reward"
                  class="instant-offer-control-width"
                  style="margin-left: 41px"
                />
              </div>

              <div class="align-items-center d-flex gap-2 mt-2">
                <span style="min-width: 40px; text-align: right">Max Reward Amount</span>
                <ep-price-control
                  formControlName="MaxRewardAmount"
                  data-cy="loyalty-program-instant-max-reward"
                  class="instant-offer-control-width"
                  style="margin-left: 4px"
                />
              </div>
              <div *ngIf="instantOfferForm.get('MaxRewardAmount')?.value === 0" class="warning-message">
                <span>0 Max Reward means there's no maximum.</span>
              </div>
            </form>
          </div>
          <div *ngIf="isBonusOfferSelected" class="d-flex flex-column mt-3 w-full align-items-center">
            <h4>Configure Bonus Offer</h4>
            <form [formGroup]="bonusOfferForm!" class="cash-back-form" data-cy="bonus-offer-form">
              <div class="align-items-center d-flex gap-2 mt-2">
                <span style="min-width: 40px; text-align: right">Bonus Reward</span>
                <ep-percentage-control
                  formControlName="BonusReward"
                  data-cy="loyalty-program-bonus-reward"
                  class="instant-offer-control-width"
                  style="margin-left: 45px"
                />
              </div>
              <div class="align-items-center d-flex gap-2 mt-2">
                <span style="min-width: 40px; text-align: right">Max Reward Amount</span>
                <ep-price-control
                  formControlName="MaxRewardAmount"
                  data-cy="loyalty-program-bonus-max-reward"
                  class="instant-offer-control-width"
                  style="margin-left: 4px"
                />
              </div>
              <div *ngIf="bonusOfferForm.get('MaxRewardAmount')?.value === 0" class="warning-message">
                <span>0 Max Reward means there's no maximum.</span>
              </div>
            </form>
          </div>
          <div class="d-flex justify-content-between mb-2 ml-auto mt-2 w-100">
            <p-button type="button" (click)="openHelpModal(); createNeedHelpAnalytics()">Need Help?</p-button>
            <p-button
              type="submit"
              [disabled]="
                (isInstantOfferSelected && instantOfferForm.invalid) ||
                (isBonusOfferSelected && bonusOfferForm.invalid) ||
                (!isBonusOfferSelected && !isInstantOfferSelected && !isBonusPointsSelected)
              "
              (onClick)="goToStep(3); populateProgramName(); updateEnrollmentData()"
            >
              Next
            </p-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Custom Loyalty Program Configuration -->
    <div class="tpn-flow-content" *ngSwitchCase="3">
      <div class="card">
        <div class="align-items-center d-flex flex-column">
          <h3>Choose your Loyalty Program:</h3>

          <div class="gap-2 justify-content-center mt-2">
            <div
              class="d-flex flex-column gap-1 loyalty-option"
              (click)="selectCustomLoyaltyProgram(2)"
              [ngClass]="{ 'loyalty-option-selected': isCustomPointsSelected || isBonusPointsSelected }"
            >
              <div class="d-flex align-items-center justify-content-between">
                <span class="font-semibold">Points:<span class="recommended-pill">Recommended</span></span>
                <i
                  class="bi bi-check-circle-fill"
                  [style.visibility]="isCustomPointsSelected || isBonusPointsSelected ? 'visible' : 'hidden'"
                  style="font-size: 14px; color: var(--sidebar-bg-active)"
                ></i>
              </div>
              <span>Members earn points on purchases. Points are redeemed for discounts.</span>
              <span>Example: 100 points redeems for $10 off their next visit.</span>
            </div>

            <div
              *ngIf="!isBonusPointsSelected"
              class="d-flex flex-column gap-1 loyalty-option"
              (click)="selectCustomLoyaltyProgram(1)"
              [ngClass]="{ 'loyalty-option-selected': isCustomCashBackSelected }"
            >
              <div class="d-flex align-items-center justify-content-between">
                <span class="font-semibold">Cash Back:</span>
                <i
                  *ngIf="isCustomCashBackSelected"
                  class="bi bi-check-circle-fill"
                  style="font-size: 14px; color: var(--sidebar-bg-active)"
                ></i>
              </div>
              <span>
                Members earn cash rewards on purchases. The amount earned is available to use on future purchases.
              </span>
            </div>
          </div>

          <div *ngIf="isCustomCashBackSelected" class="d-flex flex-column mt-3 align-items-center">
            <h4>Create Cash Back Program</h4>
            <form [formGroup]="cashBackForm!" class="cash-back-form" data-cy="cash-back-form">
              <ep-simple-text-control
                formControlName="Name"
                label="Program Name"
                data-cy="loyalty-program-cashback-name"
                class="cash-back-control-width"
              />

              <div class="align-items-center d-flex gap-2 mt-2">
                <span style="min-width: 40px; text-align: right">Cash Back Percentage</span>
                <ep-percentage-control
                  formControlName="cashBackPercentage"
                  label=""
                  data-cy="loyalty-program-cashback-percentage"
                  class="cash-back-control-width"
                />
              </div>
            </form>
          </div>

          <div
            *ngIf="isCustomPointsSelected || isBonusPointsSelected"
            class="d-flex flex-column mt-3 align-items-center"
          >
            <h4>Create Points Program</h4>
            <form [formGroup]="pointsForm!" class="points-form" data-cy="points-form">
              <ep-simple-text-control
                formControlName="Name"
                label="Program Name"
                data-cy="loyalty-program-points-name"
                class="points-control-width"
              />

              <div id="gridInputs">
                <div class="align-items-center d-flex gap-2 mt-2">
                  <span style="min-width: 40px; text-align: right">Every</span>
                  <ep-price-control
                    formControlName="QualifierAmount"
                    aria-placeholder=""
                    placeholder="$"
                    data-cy="loyalty-program-points-qualifier-amount"
                    class="points-control-money-width"
                  />
                  <span style="min-width: 70px; text-align: left">spent</span>
                </div>

                <div class="align-items-center d-flex gap-2 mt-2">
                  <span style="min-width: 40px; text-align: right">earns</span>
                  <ep-positive-integer-control
                    formControlName="EarnPoints"
                    data-cy="loyalty-program-points-earn-points"
                    class="points-control-width"
                  />
                  <span>points.</span>
                </div>

                <div class="align-items-center d-flex gap-2 mt-2">
                  <span style="min-width: 40px; text-align: right">After</span>
                  <ep-positive-integer-control
                    formControlName="RewardGoal"
                    data-cy="loyalty-program-points-reward-goal"
                    class="points-control-width"
                  />
                  <span>points</span>
                </div>
                <div class="align-items-center d-flex gap-2 mt-2">
                  <span style="min-width: 40px; text-align: right">receive</span>
                  <ep-price-control
                    formControlName="RewardAmount"
                    data-cy="loyalty-program-points-reward-amount"
                    class="points-control-money-width"
                  />
                  <span>discount.</span>
                </div>
              </div>
            </form>
          </div>

          <div *ngIf="isBonusPointsSelected" class="d-flex flex-column mt-3 align-items-center bonus-points-selected">
            <h4>Configure Enrollment Points</h4>
            <form [formGroup]="bonusPointsForm!" class="points-form" data-cy="bonus-points-form">
              <div class="align-items-center d-flex gap-2 mt-2">
                <span style="min-width: 40px; text-align: right">Enrolling earns</span>
                <ep-positive-integer-control
                  formControlName="BonusPoints"
                  data-cy="loyalty-program-bonus-points-bonus-points"
                  class="points-control-width"
                />
                <span style="min-width: 40px; text-align: right">Bonus points</span>
              </div>
            </form>
          </div>

          <div class="d-flex justify-content-between mb-2 ml-auto mt-2 w-100">
            <p-button type="button" (click)="openHelpModal(); createNeedHelpAnalytics()">Need Help?</p-button>
            <p-button
              type="submit"
              [disabled]="
                (isCustomCashBackSelected && cashBackForm.invalid) ||
                (isCustomPointsSelected && pointsForm.invalid) ||
                (isBonusPointsSelected && bonusPointsForm.invalid) ||
                (!isCustomPointsSelected && !isCustomCashBackSelected && !isBonusPointsSelected)
              "
              (onClick)="saveEnrollment()"
            >
              {{ enrollmentResponse?.StatusType === 2 ? 'Update' : 'Finish' }}
            </p-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Completion Message -->
    <div class="tpn-flow-content" *ngSwitchCase="4">
      <div *ngIf="showTerminalReadyMessage()" class="card text-center">
        <i class="bi bi-check-circle-fill" style="font-size: 48px; color: var(--header-items-color)"></i>
        <h3 class="mt-3">Your terminal is ready to use!</h3>
        <p>You can now start accepting payments and enrolling customers in the loyalty program.</p>
      </div>

      <div *ngIf="showPendingReviewMessage()" class="card text-center">
        <i class="bi bi-check-circle-fill" style="font-size: 48px; color: var(--header-items-color)"></i>
        <h3 class="mt-3">Someone will contact you shortly to complete the setup.</h3>
        <p>Thank you for your interest in our loyalty program. We will be in touch soon!</p>
      </div>

      <div *ngIf="showEnrollmentCompleteMessage()" class="card text-center">
        <i class="bi bi-check-circle-fill" style="font-size: 48px; color: var(--header-items-color)"></i>
        <h3 class="mt-3">Enrollment Completed</h3>
        <p>Check your email inbox to finish setting up your account.</p>
      </div>
    </div>

    <!-- Terms and Conditions -->
    <div class="tpn-flow-content" *ngSwitchCase="5">
      <div class="card">
        <div class="align-items-center d-flex flex-column">
          <h3>Accept our Terms and Conditions</h3>
          <div class="d-flex gap-2 justify-content-center mt-2">
            <app-terms-and-conditions (accept)="acceptTermsAndConditions()" [theme]="portalTheme!.Theme" />
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- TPN Tutorial Modal -->
<p-dialog
  [(visible)]="showTpnTutorialModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ 'max-width': '600px', width: '90vw' }"
  header="How to Find Your TPN Number"
  (onHide)="closeTpnTutorialModal()"
>
  <div class="tpn-modal-content">
    <p class="modal-description">
      Follow these simple steps to locate your 12-digit TPN number on your DvPay Lite device:
    </p>

    <div class="tutorial-steps-modal">
      <div class="step-item">
        <div class="step-number">1</div>
        <div class="step-content">
          <h4>Open DvPay Lite App</h4>
          <p>Make sure your device is powered on and the DvPay Lite application is running.</p>
        </div>
      </div>

      <div class="step-item">
        <div class="step-number">2</div>
        <div class="step-content">
          <h4>Press the Support Button</h4>
          <p>Look for and press the Support button at the bottom right of the screen.</p>
          <img src="../../assets/images/dejavoo_01.png" alt="DvPay Lite Support Button" class="tutorial-image" />
        </div>
      </div>

      <div class="step-item">
        <div class="step-number">3</div>
        <div class="step-content">
          <h4>Locate Your TPN Number</h4>
          <p>Find the 12-digit number displayed next to "TPN" on the support screen.</p>
          <img src="../../assets/images/dejavoo_02.png" alt="TPN Number Location" class="tutorial-image" />
        </div>
      </div>

      <div class="step-item">
        <div class="step-number">4</div>
        <div class="step-content">
          <h4>Enter the Number</h4>
          <p>Enter the 12-digit TPN number in the input field on the previous screen to continue the setup process.</p>
        </div>
      </div>
    </div>
    <div class="support-button" (click)="closeTpnTutorialModal()">Back</div>
    <div class="modal-footer">
      <p class="help-note d-block">
        <i class="bi bi-info-circle"></i>
        Still having trouble? Contact our support team for additional assistance at
        <a href="tel:+1-866-942-5500">Call (866) 942-5500</a>.
      </p>
    </div>
  </div>
</p-dialog>

<!-- Help Section Modal -->
<p-dialog
  [(visible)]="showHelpModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ 'max-width': '500px', width: '90vw' }"
  header="Need Help?"
  (onHide)="closeHelpModal()"
>
  <ng-template pTemplate="content">
    <div class="help-modal-content">
      <p class="modal-description">Please confirm your details so our support team can call you back.</p>
      <form [formGroup]="helpForm" class="help-form d-flex flex-column gap-3 mt-3">
        <ep-simple-text-control formControlName="FirstName" label="First Name" class="w-full" />
        <ep-international-phone-control formControlName="BusinessPhone" label="Business Phone" class="w-full" />
      </form>
      <div class="d-flex justify-content-between mt-4">
        <p-button type="button" (click)="closeHelpModal()">Cancel</p-button>
        <p-button type="button" [disabled]="helpForm.invalid" (click)="submitHelpRequest()">Submit</p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<app-loading-spinner *ngIf="isLoading$ | async" [message]="'Loading...'" class="text-center" />
